import React from 'react';
import './CloseButton.css';

class CloseButton extends React.Component {
  
  render() {
      return(
        <button
            className="moons-circular-close"
            onClick={ () => this.props.onClick() }
            >
                <span className="fa fa-times"></span>
        </button>

      )
  }

}

export default CloseButton;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/CloseButton/CloseButton.js